<template>
  <div>
    <el-row>
      <el-col :span="24">
        <Header></Header>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="4">
        <MenuList></MenuList>
      </el-col>
      <el-col :span="20">


        <div
          style="display: flex;justify-content: space-between;margin-right: 20px;align-items: center;margin-top: 20px;">
          <div style="display: flex;align-items: center;height:50px;">
            <el-tooltip class="item" effect="dark" content="按照姓名和学号查询成绩" placement="top">
              <div style="white-space:nowrap;margin-left: 10px;margin-right: 5px;font-size: 16px;">搜索</div>
              <div style="display: flex;margin-left: 20px;">
                <el-input placeholder="输入姓名或学号" v-model="condition" clearable size="40"></el-input>
                <el-button type="primary" round @click="searchByKey" style="margin-left: 10px;">立即查询</el-button>
                <el-button type="primary" round @click="showAllData">显示全部</el-button>
              </div>
            </el-tooltip>
          </div>

          <div style="display: flex;align-items: center;">
            <el-tooltip class="item" effect="dark" content="给成绩单上增加通知,查询结果后面显示." placement="top">
              <el-button type="success" round @click="publishNotice">添加通知</el-button>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="删除不需要显示的列." placement="top">
              <el-button type="warning" round @click="deleteColumn">删除整列</el-button>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="把现有的excel成绩单导入到这里." placement="top">
              <el-button type="primary" round @click="importScoreExcel">批量修正或增补成绩</el-button>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="导出成绩单,用于各个老师录成绩后合并成绩单." placement="top">
              <el-button type="primary" round @click="exportExcel">导出成绩单</el-button>
            </el-tooltip>
          </div>
        </div>
        <el-divider content-position="center"><span style="font-size: 22px;">{{exam}}</span></el-divider>
        <div style="padding: 10px;">

          <el-table border :data="filterData" style="width:100%" @sort-change="changeSort"
            :header-cell-style="{background:'#eef1f6',color:'#606266'}">
            <el-table-column type="index" fixed :index="indexMethod" label="序号" width="60" header-align="center"
              align="center">
            </el-table-column>
            <el-table-column type="index" fixed label="查询状态" width="60" header-align="center" align="center">

              <template slot-scope="scope">
                <span v-if="scope.row.searched=='1'">已查</span>
              </template>

            </el-table-column>
            <el-table-column fixed label="姓名">
              <template slot-scope="scope">
                <span
                  @click="editContent(scope.$index,scope.row.student_name,scope.row.student_num,scope.row.student_name,'姓名')"
                  style="text-decoration: underline;cursor:pointer;">{{scope.row.student_name}}</span>
              </template>
            </el-table-column>
            <el-table-column fixed label="学号">
              <template slot-scope="scope">
                <span
                  @click="editContent(scope.$index, scope.row.student_name,scope.row.student_num,scope.row.student_num,'学号')"
                  style="text-decoration: underline;cursor:pointer;">{{scope.row.student_num}}</span>
              </template>
            </el-table-column>

            <el-table-column v-for="(item,i) in courses_list" v-bind:key="i">
              <template slot="header" slot-scope="scope">
                <div>{{item.course}}</div>
              </template>
              <template slot-scope="scope">
                <span style="text-decoration: underline;cursor:pointer;white-space: pre-wrap;"
                  @click="editScore(scope.$index, scope.row.student_name,scope.row.student_num,item.course,getScore(scope.$index,item.course))">{{ getScore(scope.$index,item.course)}}</span>

                <span>
                  <span v-if="item.is_score=='1'" style="color:red;">*</span>
                </span>

              </template>
            </el-table-column>

            <el-table-column fixed="right" label="评语" header-align="center" align="center" width="60">
              <template slot-scope="scope">
                <span v-if="filterData && filterData[scope.$index]" style="cursor: pointer;font-size: 18px;"
                  @click="writeComment(scope.$index, filterData)">
                  <span v-if="filterData[scope.$index].comment!=''"><i style="color:red;"
                      class="el-icon-chat-dot-square"></i></span>
                  <span v-else><i class="el-icon-chat-dot-square"></i></span>
                </span>
              </template>
            </el-table-column>

            <el-table-column label="操作" header-align="center" align="center" fixed="right" width="120">
              <template slot-scope="scope">
                <el-button @click.native.prevent="delExamScore(scope.$index, filterData)" type="text" size="small">
                  删除
                </el-button>
                <!--               <el-button @click.native.prevent="expandUserCount(scope.$index, filterData)" type="text" size="small">
                  增加可查人数
                </el-button> -->
                <el-button @click.native.prevent="mutiChildrenSetting(scope.$index, filterData)" type="text"
                  size="small">
                  多子女查询设置
                </el-button>

                <el-button @click.native.prevent="grantAward(scope.$index, filterData)" type="text" size="small">
                  发个奖状
                </el-button>

                <el-button @click.native.prevent="writeComment(scope.$index, filterData)" type="text" size="small">
                  <span>
                    <span v-if="filterData[scope.$index].comment!=''">
                      修改评语
                    </span>
                    <span v-else>
                      填写评语
                    </span>
                  </span>
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div style="color:red;padding-left: 10px;text-align: center;">注:点击姓名或者学号可以修改</div>
        <div style="text-align: center;padding-bottom: 30px;">
          <el-pagination @current-change="handleCurrentChange" layout="total, prev, pager, next" :total="total_record"
            :page-size="pageSize">
          </el-pagination>
        </div>
      </el-col>
    </el-row>
    <el-row>

    </el-row>

    <el-dialog title="重要提示" :visible.sync="dialogVisible" width="30%">
      <span>{{msg}}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="delExamScoreRecord">删 除</el-button>
      </span>
    </el-dialog>

    <el-dialog title="修改可查人数" :visible.sync="expandDialogVisible" width="30%">
      <span>
        <div>修改查询过<span style="font-weight: bold;">{{expandStudentName}}</span>设备的可查人数:</div>
        <div style="margin-top: 20px;"><span>可查人数:</span>
          <el-input-number v-model="expandCurrentCount" :min="1" :max="5" label=""></el-input-number>
        </div>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="expandDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="expandUserUpdate()">修 改</el-button>
      </span>
    </el-dialog>


    <el-dialog title="多子女查询设置" :visible.sync="mutiChildrenDialogVisible" width="40%">
      <span>
        <div>一部手机只能查询一个成绩，如果家长已经查询了其他孩子成绩且已经锁定，请点击下面的“解除限制,允许查询”按钮，则系统会解除对<span
            style="font-weight: bold;">{{expandStudentName}}</span>的成绩查询限制！</div>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="releaseCurrentStudent()">立即解除限制,允许查询成绩</el-button>
        <el-button @click="mutiChildrenDialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>

    <el-dialog title="修改成绩" :visible.sync="editDialogVisible">
      <el-form :model="form">
        <el-form-item label="姓名" :label-width="formLabelWidth">
          <el-input v-model="form.student_name" autocomplete="off" autofocus></el-input>
        </el-form-item>
        <el-form-item label="学号" :label-width="formLabelWidth">
          <el-input v-model="form.student_num" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="成绩" :label-width="formLabelWidth">
          <el-input v-model="form.score" autocomplete="off"></el-input>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="editScoreSave">保 存</el-button>
      </div>
    </el-dialog>

    <el-dialog title="重新导入成绩" :visible.sync="importDialogVisible">
      <div style="color: red;padding-bottom: 10px;">注意事项:</div>
      <div style="color: red;padding-bottom: 10px;">1.重新导入会删除系统中本次考试的所有成绩数据，包括手工录入的数据</div>
      <div style="padding-bottom: 10px;">2.只能上传从本系统下载的excel模板文件填写的成绩单,<el-link target="_blank"
          href="http://www.sales1.top/score/files/single_course.xls" :underline="false" style="margin-left:15px">点击下载模板
        </el-link>
      </div>
      <div style="padding-bottom: 10px;">3.本功能在上次导入数据有错误，需要重新导入时使用</div>
      <el-upload class="upload-demo" :http-request="uploadFile" action :on-preview="handlePreview"
        :on-remove="handleRemove" :on-change="fileChange" :before-remove="beforeRemove" accept=".xls" multiple
        :limit="1" :on-exceed="handleExceed" :file-list="fileList">
        <div class="uploadFileStyle">
          <div slot="tip" class="el-upload__tip" style="font-size: 18px;"></div>
          <el-button type="primary" plain>+点击上传Excel文件</el-button>

        </div>
      </el-upload>
      <div slot="footer" class="dialog-footer">
        <el-button @click="importDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="importScoreFile">导 入</el-button>
      </div>
    </el-dialog>

    <!--下载文件-->
    <el-dialog width="30%" :close-on-click-modal="false" title="导出成功" :visible.sync="downloadExcelDialogVisible">
      <!-- <el-form-item label="卷面分"> -->
      <div class="colStyle">
        <div class="colStyle">
          <!-- <a :href="excel_file_url" target="_blank">点击下载excel文件</a> -->
          <!-- <div name="downloadfile" :onclick="downloadExcel">点击下载excel文件</div> -->
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="downloadExcelDialogVisible=false">关闭</el-button>
      </div>
    </el-dialog>

    <el-dialog title="修改内容" :visible.sync="editContentDialogVisible" width="30%">
      <div>
        <div>请修改<span style="color:red;font-size: 20px;font-weight: bold;">{{edit_content_header}}</span>数据:</div>
        <div>
          <el-form :model="form">
            <el-form-item>
              <el-input v-model="edit_content" autocomplete="off" autofocus></el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveContent">保 存</el-button>
        <el-button @click="editContentDialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>

    <el-dialog title="修改内容" :visible.sync="editScoreContentDialogVisible" width="30%">
      <div>
        <div>请修改<span style="color:red;font-size: 20px;font-weight: bold;">{{edit_course_header}}</span>内容:</div>
        <div>
          <el-form :model="form">
            <el-form-item>
              <el-input v-model="edit_score_content" autocomplete="off" autofocus></el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveScoreContent">保 存</el-button>
        <el-button @click="editScoreContentDialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>

    <!--扩展人数失败提示-->
    <el-dialog width="30%" :close-on-click-modal="false" title="扩展人数失败" :visible.sync="expandUserFailureDialogVisible">
      <div class="colStyle">
        <div class="colStyle">
          扩展查询名额需要知道查询手机的设备ID,由于该学生的成绩还没有查询过,所以系统不知道该扩展哪个手机,等家长或学生成功查询成功查询后再来扩展人数吧!
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="expandUserFailureDialogVisible=false" type="primary">好 的</el-button>
      </div>
    </el-dialog>


    <!--删除整列数据-->
    <el-dialog title="删除整列" :visible.sync="deleteColumnDialogVisible" width="40%">
      <div>
        <div>删除列主要用于删除不想让家长或学生看到的列，请在下面选择要删除的列：</div>
        <div style="margin-top: 10px;">
          <!-- <el-form :model="form">
            <el-form-item>
              <el-input v-model="edit_content" autocomplete="off" autofocus></el-input>
            </el-form-item>
          </el-form> -->
          <el-select v-model="selectedColumName" placeholder="点我请选择要删除的列">
            <el-option v-for="item in columNames" :key="item.course" :label="item.course" :value="item.course">

              <span>{{item.course}}</span>

            </el-option>
          </el-select>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="deleteColumnAction">立即删除</el-button>
        <el-button @click="deleteColumnDialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>

    <!--发奖提示-->
    <el-dialog title="如何发电子奖状？" :visible.sync="howToUseElectricAwardDialogVisible" width="40%">
      <div>
        <div>奖状为电子版，需要在手机端小程序内操作，操作步骤如下：</div>
        <div style="margin-top: 10px;">
          <div style="margin-top: 10px;">1.在手机微信中打开快查成绩小程序；</div>
          <div style="margin-top: 10px;">2.点开成绩单，在表格中点击要发奖的学生姓名(可搜索)；</div>
          <div style="margin-top: 10px;">3.点击“发奖状”功能开始制作奖状，制作完后点右下角“立即发奖”即可;学生查到成绩后会在成绩结果界面上提示有电子奖状。</div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="howToUseElectricAwardDialogVisible = false">知道了</el-button>
      </span>
    </el-dialog>


    <!--填写评语-->
    <el-dialog :title="commentDialogTitle" :close-on-click-modal="false" :visible.sync="commentDialogVisible"
      width="40%">
      <div>
        <!-- <div>请填写评语：</div> -->
        <div style="">
          <textarea v-model="teacher_comment" rows="8" style="width: 100%;" placeholder="点这里填写评语"></textarea>
        </div>
        <div>注：评语会显示在微信小程序查询结果界面上</div>
      </div>
      <span slot="footer" class="dialog-footer">

        <el-button type="danger" style="margin-right: 80px;" @click="deleteComment()"
          v-if="filterData && filterData[commentIndex] && filterData[commentIndex].comment">删除评语</el-button>

        <el-button type="warning" @click="generateTeacherComment()">自动生成评语</el-button>
        <el-button type="primary" @click="commentDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="saveComment()">保存评语</el-button>
      </span>
    </el-dialog>


    <!--学生标签选择-->
    <el-dialog :title="studentTagsSelectorDialogTitle" :close-on-click-modal="false"
      :visible.sync="studentTagsSelectorDialogVisible" width="50%">
      <div>
        <div>系统会依据整体成绩单和您选定的学生特点填写评语，请选择该学生的特点(最多3个)</div>
        <div style="margin-top: 20px;">
          <el-checkbox-group v-model="selected_tags">
            <el-checkbox v-for="(item,index) in student_tags" :key="index" :label="item.tag"
              style="margin: 10px;"></el-checkbox>
          </el-checkbox-group>
        </div>

      </div>
      <span slot="footer" class="dialog-footer">

        <el-button type="primary" @click="studentTagsSelectorDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="generateTeacherCommentAction()">立即生成评语</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
  import MenuList from './menu.vue'
  import Header from './head.vue'

  export default {
    components: {
      MenuList,
      Header
    },
    created() {
      this.username = this.$session.get('USERNAME') // 获取session
      this.examID = this.$route.params.id
      this.exam = this.$route.params.exam
      // console.log('传递过来的参数是:' + this.examID)
      this.loadData('', '')
      this.loadStudents()
      this.loadExamColumns()
      this.loadStudentTags()
    },
    // 搜索数据
    computed: {
      filterData: function() {
        // let that = this
        // var input = this.condition && this.condition.toLowerCase()
        // var items = this.tableData
        // var items1
        // if (input) {
        //   items1 = items.filter(function(item) {
        //     return Object.keys(item).some(function(key1) {
        //       return String(item[key1])
        //         .toLowerCase()
        //         .match(input)
        //     })
        //   })
        // } else {
        //   items1 = items
        // }
        // that.currentItems = items1
        // return items1
        var items = this.tableData
        return items
      }
    },
    data() {
      return {

        username: '',

        exam: '',

        courses_list: [],

        condition: '',
        examID: '',
        tableData: [],
        currentItems: [],
        dialogVisible: false,
        editDialogVisible: false,
        importDialogVisible: false,
        fileList: [],
        msg: '',
        selectedExamScoreID: '',
        position: -1,
        form: {
          student_name: '',
          student_num: '',
          score: '',
          id: ''
        },
        formLabelWidth: '80px',

        students: [],
        // allSelectNav: 当前下拉菜单的数组 ;
        studentsTemporary: [],
        selectedStudentName: '',
        selectedStudentNum: '',
        selectedStudentGrade: '',
        selectedStudentID: '',

        blurFocus: false,

        downloadExcelDialogVisible: false,
        excel_file_url: '',

        editContentDialogVisible: false,
        edit_content_header: '',
        edit_content: '',
        edit_index: -1,
        edit_row: {},
        edit_student_name: '',
        edit_student_num: '',
        edit_content_label: '',
        edit_old_content: '',

        expandDialogVisible: false,
        expandStudentName: '',
        expandStudentNum: '',
        expandCurrentCount: 1,
        expandEquipment: '',

        currentPage: 1,
        pageSize: 10,
        total_record: 100,

        expandUserFailureDialogVisible: false,

        editScoreContentDialogVisible: false, // 修改成绩
        edit_course_header: '',
        edit_score_content: '',
        edit_student_name: '',
        edit_student_num: '',


        deleteColumnDialogVisible: false,
        selectedColumName: '',
        columNames: [],


        //多子女解锁
        mutiChildrenDialogVisible: false,

        howToUseElectricAwardDialogVisible: false,


        commentDialogTitle: '',
        commentDialogVisible: false,
        teacher_comment: '',

        commentStudentName: '',
        commentStudentNum: '',
        commentIndex: '',


        student_tags: [], //系统默认学生的标签
        selected_tags: [],

        studentTagsSelectorDialogTitle: '',
        studentTagsSelectorDialogVisible: false
      }
    },
    methods: {
      loadExamColumns() {
        let that = this


        var requestUrl = '/score/web/_load_exam_columns.jsp'
        this.axios.get(requestUrl, {
            params: {
              exam_id: that.examID,
            }
          }).then(function(response) {



            that.columNames = response.data.courses
            // console.log(response.data.courses,that.columNames,'ddddddddd')

          })
          .catch(function(error) {
            console.log(error)

          })
      },
      loadStudentTags() {
        let that = this


        var requestUrl = '/score/web/_load_student_tags.jsp'
        this.axios.get(requestUrl, {
            params: {}
          }).then(function(response) {



            that.student_tags = response.data.student_tags
            // console.log(response.data.courses,that.columNames,'ddddddddd')

          })
          .catch(function(error) {
            console.log(error)

          })
      },
      loadData(sortFieldName, sortType) {

        this.handleCurrentChange(1)
      },
      handleCurrentChange(currentPage) {
        console.log('加载数据')
        let that = this

        // 开启loading
        const load = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        var requestUrl = '/score/web/_load_exam_detail.jsp'
        this.axios.get(requestUrl, {
            params: {
              exam_id: that.examID,
              sort_field: '',
              sort_type: '',
              current_page: currentPage,
              page_size: that.pageSize,
              condition: that.condition
            }
          }).then(function(response) {
            that.courses_list = response.data.courses_list

            that.tableData = response.data.student_score_list
            that.currentItems = that.tableData
            that.total_record = response.data.total_record

            // that.condition = ''
            // console.log(that.tableData)

            that.$forceUpdate()

            load.close()
          })
          .catch(function(error) {
            console.log(error)

            load.close()
          })
      },

      loadStudents() {
        console.log('加载数据')
        let that = this

        // 开启loading

        var requestUrl = '/score/web/_get_students.jsp'
        this.axios.get(requestUrl, {
            params: {
              username: that.username
            }
          }).then(function(response) {
            that.students.length = 0
            that.students = response.data
          })
          .catch(function(error) {
            console.log(error)
          })
      },

      delExamScore(index, rows) {
        this.selectedExamScoreID = this.currentItems[index].id

        this.position = index



        this.msg = '确定要删除序号为"' + (index + 1) + '"的整行数据吗？'

        this.dialogVisible = true



        // console.log(rows[index].exam)
      },
      editExamScore(index, rows) {
        this.position = index

        this.form.id = this.currentItems[index].id
        this.form.student_name = this.currentItems[index].student_name
        this.form.student_num = this.currentItems[index].student_num
        this.form.score = this.currentItems[index].score

        this.editDialogVisible = true
      },

      delExamScoreRecord() {
        let that = this
        this.dialogVisible = false

        // console.log('shanchu ')

        let data = {
          exam_id: that.examID,
          student_name: that.currentItems[that.position].student_name,
          student_num: that.currentItems[that.position].student_num
        }

        // console.log('&&&&&&&' + that.username)

        var qs = require('qs')

        var requestUrl = '/score/web/_delete_student_all_score.jsp'

        // 开启loading
        const load = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        this.axios.post(
            requestUrl,
            qs.stringify(data), {
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
              }
            }
          ).then(function(response) {
            var rowsNum = that.filterData.length

            var i = 0
            for (; i < rowsNum; i++) {
              let tempRow = that.filterData[i]
              // console.log(tempRow.id)

              if (tempRow.id === that.selectedExamScoreID) {
                that.filterData.splice(i, 1)
                // that.currentItems.splice(that.position, 1)
                // console.log('#########################')
                break
              }
            }

            that.loadData('', '')

            that.$message.success('删除成功！')
          })
          .catch(function(error) {
            console.log(error)
          })
      },
      addScore() {
        // 数据校验
        if (this.selectedStudentID === '') {
          this.$message.error('请输入学生姓名')
          return
        }
        if (this.form.student_num === '') {
          this.$message.error('请输入学号，查询使用，可以自行设置，不得少于4位数字')
          return
        }

        if (this.form.student_num.length < 4) {
          this.$message.error('学号必须是4位或者更多')
          return
        }

        if (this.form.score === '') {
          this.$message.error('请输入成绩')
          return
        }

        // id转换成姓名
        for (var i = 0; i < this.students.length; i++) {
          var id = this.students[i].id
          if (id === this.selectedStudentID) {
            this.form.student_name = this.students[i].student_name
            break
          }
        }

        if (this.form.student_name === '') {
          this.form.student_name = this.selectedStudentID
        }

        let that = this
        var requestUrl = '/score/web/_score_add_save.jsp'
        this.axios.get(requestUrl, {
            params: {
              exam_id: that.examID,
              student_name: that.form.student_name,
              student_num: that.form.student_num,
              score: that.form.score
            }
          }).then(function(response) {
            console.log(response.data.result)
            var result = response.data.result
            if (result === '0') {
              // that.$router.push({
              //   name: routeName,
              //   params: {
              //     id: examID,
              //     course: that.course
              //   }
              // })

              that.form.student_name = ''
              that.form.student_num = ''
              that.form.score = ''
              that.selectedExamScoreID = null

              that.loadData('', '')

              that.$message('添加成功！')
            } else {
              that.$message.error('保存失败！')
            }
          })
          .catch(function(error) {
            console.log(error)
          })
      },
      emptyScoreList() {
        let that = this

        this.$confirm('是否要清除本次考试所有的成绩?', '警告', {
          confirmButtonText: '清空',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // 调用删除接口

          // 开启loading
          const load = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          })

          var requestUrl = '/score/web/_score_del_all.jsp'
          this.axios.get(requestUrl, {
              params: {
                exam_id: that.examID
              }
            }).then(function(response) {
              that.tableData = []
              that.$message('清空成功！')
              load.close()
            })
            .catch(function(error) {
              console.log(error)
              load.close()
            })
        }).catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: '已取消删除'
          // })
        })
      },
      editScoreSave() {
        let that = this

        // 校验数据
        if (this.form.student_name === '') {
          this.$message.error('请输入姓名')
          return
        }

        if (this.form.student_num === '') {
          this.$message.error('请输入学号')
          return
        }

        if (this.form.score === '') {
          this.$message.error('请输入成绩')
          return
        }

        // if (!this.isNumber(this.form.score)) {
        //   this.$message.error('成绩必须是数字，如:99.5')
        //   return
        // }

        var requestUrl = '/score/web/_score_edit_save.jsp'
        this.axios.get(requestUrl, {
            params: {
              student_id: that.currentItems[that.position].id,
              exam_id: that.currentItems[that.position].exam_key,
              student_name: that.form.student_name,
              student_num: that.form.student_num,
              score: that.form.score
            }
          }).then(function(response) {
            // 更新表格的数据
            that.currentItems[that.position].student_name = that.form.student_name
            that.currentItems[that.position].student_num = that.form.student_num
            that.currentItems[that.position].score = that.form.score

            that.editDialogVisible = false

            that.$message('修改成功！')
          })
          .catch(function(error) {
            console.log(error)
            that.$message(error)
            that.editDialogVisible = false
          })
      },
      // 从后台获取数据,重新排序
      changeSort(val) {
        console.log(val) // column: {…} order: "ascending" prop: "date"
        // 根据当前排序重新获取后台数据,一般后台会需要一个排序的参数
        // this.loadData(val.prop, val.order)
      },
      reImportFile() {
        this.fileList = []
        this.importDialogVisible = true
      },

      handleRemove(file, fileList) {
        this.fileList = []
      },
      handlePreview(file) {},
      uploadFile(file) {
        // this.data.append('file', file.file)
      },
      handleExceed(files, fileList) {
        this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`)
      },
      beforeRemove(file, fileList) {
        return this.$confirm(`确定移除 ${file.name}？`)
      },

      fileChange(file, fileList) {
        this.fileList = fileList
      },
      importScoreFile() {
        if (this.fileList.length === 0) {
          this.$message.error('请上传excel文件！')
          return
        }

        let that = this

        let data = new FormData()
        data.set('exam_key', this.examID)

        let tmpExcelFile = this.fileList[0].raw

        // console.log(tmpExcelFile)

        data.append('file', tmpExcelFile)

        // 开启loading
        const load = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        var requestUrl = '/score/web/_re_import_excel.jsp'
        this.axios.post(requestUrl, data, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then(res => {
          if (res.data.result === '2') {
            that.$alert('导入失败！请下载系统中模板，并按照模板要求粘贴成绩。三个必须填写的列是姓名，学号，成绩。顺序和表头的名称不能修改。')
          } else {
            that.$message('数据导入完成！！')

            that.loadData()
          }
          that.fileList = []
          this.importDialogVisible = false

          load.close()
        }).catch(err => {
          that.$message.error(err)
          console.log(err)
          load.close()
          this.$router.push({
            name: 'exam_detail',
            params: {
              id: that.examID
            }
          })
        })
      },
      indexMethod(index) {
        return index + 1
      },
      setStudentName(e) {
        this.selectedStudentID = e.target.value
      },
      clickStudentName(val) {
        for (var i = 0; i < this.students.length; i++) {
          var id = this.students[i].id
          if (id === this.selectedStudentID) {
            console.log('学号:' + this.students[i].student_num)
            this.form.student_num = this.students[i].student_num
            break
          }
        }

        this.jumpToScoreInput()
      },
      jumpToScoreInput() {
        if (this.form.student_num.length < 4) {
          this.$message.error('学号太短，至少4位以上')
        } else {
          this.$refs.scoreInput.focus()
        }
      },
      jumpToStuNumInput(e) {
        this.selectedStudentID = e.target.value
        this.$refs.StuNumInput.focus()
        // this.$message.error('监听到了' + e.target.value)
      },
      getScore(index, course) {
        // console.log(index + '    ' + course)

        let score = this.filterData[index][course]
        return score
      },
      exportExcel() {
        console.log('导出成绩单')

        let that = this

        // 开启loading
        const load = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        var requestUrl = '/score/web/_export_exam_to_excel.jsp'
        this.axios.get(requestUrl, {
            params: {
              exam_id: that.examID
            }
          }).then(function(response) {
            // console.log(response.data.file_name)

            var url = '/score' + response.data.file_name
            // that.excel_file_url = url
            // that.downloadExcelDialogVisible = true
            window.open(url)

            load.close()
          })
          .catch(function(error) {
            console.log(error)

            load.close()
          })
      },
      downloadExcel() {
        let a = document.createElement('a')
        a.href = this.excel_file_url
        a.click()
      },
      editContent(index, studentName, studentNum, content, label) {
        this.edit_content_header = label

        this.edit_student_name = studentName
        this.edit_student_num = studentNum

        this.edit_content = content

        this.edit_index = index

        this.editContentDialogVisible = true
      },
      saveContent() {
        let that = this

        // 开启loading
        const load = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        var requestUrl = '/score/web/_update_exam_score_content.jsp'
        this.axios.get(requestUrl, {
          params: {
            exam_id: that.examID,
            student_name: that.edit_student_name,
            student_num: that.edit_student_num,
            edit_new_content: that.edit_content,
            edit_field: that.edit_content_header
          }
        }).then(function(response) {
          that.$message.success('更新成功！！')
          that.loadData('', '')
          that.editContentDialogVisible = false
          load.close()
        })
      },
      expandUserCount(index, rows) {
        this.selectedExamScoreID = this.currentItems[index].id

        this.position = index

        this.expandStudentName = this.currentItems[index].student_name
        this.expandStudentNum = this.currentItems[index].student_num

        let that = this

        // 开启loading
        const load = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        var requestUrl = '/score/web/_load_search_info.jsp'
        that.axios.get(requestUrl, {
          params: {
            student_name: that.expandStudentName,
            student_num: that.expandStudentNum
          }
        }).then(function(response) {
          if (response.data.result === '1') {
            that.expandEquipment = response.data.search_info.equipment
            that.expandDialogVisible = true
          } else {
            that.expandUserFailureDialogVisible = true

            // that.$message.error('“' + that.expandStudentName + '”的成绩还没有被查询，请查询后再修改该设备的可查人数！')
          }

          load.close()
        })
      },
      mutiChildrenSetting(index, rows) {

        this.expandStudentName = this.currentItems[index].student_name
        this.expandStudentNum = this.currentItems[index].student_num

        this.mutiChildrenDialogVisible = true
      },
      grantAward(index, rows) {
        this.howToUseElectricAwardDialogVisible = true
      },
      writeComment(index, rows) {
        this.commentDialogTitle = '给"' + rows[index].student_name + '"写评语'
        this.commentStudentName = rows[index].student_name
        this.commentStudentNum = rows[index].student_num
        this.commentIndex = index
        this.teacher_comment = rows[index].comment
        this.commentDialogVisible = true
      },
      saveComment() {



        let that = this

        if (this.isEmpty(this.teacher_comment)) {
          this.$message.error('评语不能为空！')
          return
        }

        // 开启loading
        const load = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        var requestUrl = '/score/web/_teacher_comment_save.jsp'
        that.axios.get(requestUrl, {
          params: {
            exam_id: that.examID,
            student_name: that.commentStudentName,
            student_num: that.commentStudentNum,
            content: that.teacher_comment
          }
        }).then(function(response) {
          if (response.data.result == '1') {
            that.filterData[that.commentIndex].comment = that.teacher_comment
            console.log(that.filterData[that.commentIndex])
            that.commentDialogVisible = false
          }

          load.close()

          that.$message.success('保存成功！')
        })



      },
      deleteComment() {
        let that = this

        this.$confirm('确定要删除已经写给' + this.commentStudentName + '"的评语吗?', '操作提醒', {
          confirmButtonText: '立即删除',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // 开启loading
          const load = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          })

          var requestUrl = '/score/web/_teacher_comment_delete.jsp'
          this.axios.get(requestUrl, {
            params: {
              exam_id: that.examID,
              student_name: that.commentStudentName,
              student_num: that.commentStudentNum,
            }
          }).then(function(response) {
            // console.log(response)

            if (response.data.result == '1') {
              that.filterData[that.commentIndex].comment = ''
              that.teacher_comment = ''
              that.commentDialogVisible = false
              that.$message.success('删除成功！！')
            } else {
              that.$message.error('删除失败！！')
            }

            load.close()

            // that.loadData('', '')

          }).catch(function(error) {
            console.log(error)
            load.close()
          })
        }).catch(() => {

        })
      },
      releaseCurrentStudent() {
        let that = this

        // 开启loading
        const load = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        var requestUrl = '/score/web/_realease_stutdent_lock.jsp'
        that.axios.get(requestUrl, {
          params: {
            exam_key: that.examID,
            student_name: that.expandStudentName,
            student_num: that.expandStudentNum
          }
        }).then(function(response) {
          if (response.data.result === '1') {
            that.mutiChildrenDialogVisible = false
          } else {
            that.expandUserFailureDialogVisible = true
          }

          load.close()

          that.$message.success('取消限制操作成功！')
        })

      },
      expandUserUpdate() {
        let that = this

        // 开启loading
        const load = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        var requestUrl = '/score/web/_teacher_expand_count_.jsp'
        that.axios.get(requestUrl, {
          params: {
            equipment: that.expandEquipment,
            expand_num: that.expandCurrentCount,
            phone: that.username
          }
        }).then(function(response) {
          that.expandDialogVisible = false
          that.expandCurrentCount = 1
          that.$message.success('扩展成功！')
          load.close()
        })
      },
      searchByKey() {
        this.handleCurrentChange(1)
      },
      showAllData() {
        this.condition = ''
        this.handleCurrentChange(1)
      },
      editScore(index, student_name, student_num, course, score) {
        console.log(index, student_name, student_num, course, score)

        this.edit_course_header = course
        this.edit_score_content = score
        this.edit_student_name = student_name
        this.edit_student_num = student_num

        this.editScoreContentDialogVisible = true
      },
      saveScoreContent() {
        let that = this

        // 开启loading
        const load = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        var requestUrl = '/score/web/_update_exam_score_for_edit.jsp'
        this.axios.get(requestUrl, {
          params: {
            exam_id: that.examID,
            student_name: that.edit_student_name,
            student_num: that.edit_student_num,
            course: that.edit_course_header,
            score: that.edit_score_content
          }
        }).then(function(response) {
          that.$message.success('更新成功！！')
          that.loadData('', '')
          that.editScoreContentDialogVisible = false
          load.close()
        })
      },
      publishNotice() {
        var examID = this.examID
        var examName = this.exam

        this.$router.push({
          name: 'exam_edit_html',
          params: {
            exam_key: examID,
            exam_name: examName,
            page_from: 'detail'
          }
        })
      },
      emptyExam() {


        let that = this

        this.$confirm('确定要清空此成绩单中的所有成绩数据吗?', '操作提醒', {
          confirmButtonText: '全部清空',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // 开启loading
          const load = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          })

          var requestUrl = '/score/web/_delete_all_score.jsp'
          this.axios.get(requestUrl, {
            params: {
              username: that.username,
              exam_key: that.examID
            }
          }).then(function(response) {
            console.log(response)

            if (response.data.result == '1') {
              that.$message.success('清空成功！！')
            } else {
              that.$message.error(response.data.message)
            }

            load.close()

            that.loadData('', '')

          }).catch(function(error) {
            console.log(error)
            load.close()
          })
        }).catch(() => {

        })
      },
      importScoreExcel() {
        let that = this
        this.$router.push({
          name: 'exam_score_import_anyfile',
          params: {
            exam_id: that.examID,
            exam: that.exam
          }
        })
      },
      deleteColumn() {
        this.deleteColumnDialogVisible = true
      },

      deleteColumnAction() {
        console.log(this.selectedColumName)
        if (this.selectedColumName == '') {
          this.$message.error('列名不能为空，请选择！')
          return
        }


        let that = this
        var title = '删除"' + this.selectedColumName + '"后查询结果将不再显示，如需显示需要重新导入数据，现在删除吗？'
        this.$confirm(title, '操作提醒', {
          confirmButtonText: '删除',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // 开启loading
          const load = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          })

          var tmpColumnName = this.selectedColumName

          var requestUrl = '/score/web/_delete_exam_column.jsp'
          that.axios.get(requestUrl, {
            params: {
              exam_key: that.examID,
              column_name: tmpColumnName
            }
          }).then(function(response) {
            // console.log(response)
            that.deleteColumnDialogVisible = false
            load.close()

            if (response.data.result == '1') {
              that.selectedColumName = ''

              that.$message.success('删除成功！！')

              that.courses_list = []
              that.loadExamColumns()

            } else {
              that.$message.error(response.data.message)
            }

            that.loadData('', '')

            // that.handleCurrentChange(1)

          }).catch(function(error) {
            console.log(error)
            load.close()
          })
        }).catch(() => {

        })


      },
      generateTeacherComment() {
        this.studentTagsSelectorDialogTitle = '请选择"' + this.commentStudentName + '"主要特点(最多可选3个)'
        this.studentTagsSelectorDialogVisible = true
      },
      generateTeacherCommentAction() {
        if (this.selected_tags.length > 3) {
          this.$message.error('学生的特点最多选3个哦~')
          return
        }

        if (this.selected_tags.length == 0) {
          this.$message.error('请选择学生的主要特点！')
          return
        }


        let that = this
        var title = '每次生成评语需要十几秒时间或更长时间，您现在要继续生成评语吗？'
        this.$confirm(title, '操作提醒', {
          confirmButtonText: '继续',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // 开启loading
          const load = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          })

          var tagStr = ''
          for (var i = 0; i < that.selected_tags.length; i++) {
            if (i == 0) {
              tagStr = that.selected_tags[0]
            } else {
              tagStr = tagStr + '、' + that.selected_tags[i]
            }
          }

          var requestUrl = '/score/web/_generate_student_teacher_comment.jsp'
          that.axios.get(requestUrl, {
            params: {
              exam_id: that.examID,
              student_name: that.commentStudentName,
              student_num: that.commentStudentNum,
              selected_tags: tagStr
            }
          }).then(function(response) {
            load.close()

            if (response.data.result == '1') {
              that.teacher_comment = response.data.teacher_comment
              that.studentTagsSelectorDialogVisible = false
            }


          }).catch(function(error) {
            console.log(error)
            load.close()
          })
        }).catch(() => {

        })


      }
    }
  }
</script>

<style>
  .el-table__row td:not(.is-hidden):nth-last-child(2) {
    border-left: 1px solid #EBEEF5;
  }

  .el-table__header th:not(.is-hidden):nth-last-child(2) {
    border-left: 1px solid #EBEEF5;
  }


  .el-table__fixed {
    height: 100% !important;
  }

  .el-table__fixed-right {
    height: 100% !important;
  }

  /*  .el-table__header-wrapper tr th:nth-last-child(2) {
    border-right: #ff0000;
  }

  .el-table__body-wrapper tr td:nth-last-child(2) {
    border-right: #ff0000;
  } */

  .searchStyle {
    display: flex;
    width: 200px;
    align-items: center;

  }

  .actionBarStyle {
    display: flex;
    justify-content: space-between;
  }

  .titleStyle {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 20px;
  }

  .addRecordStyle {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }

  .searchBarStyle {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/exam_detail.vue